import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { type ReserveType } from './itinerary';

export interface DateSpanObject {
    start: Date | null;
    end: Date | null;
}

export interface Location<T extends Location<T> = Location<any>> {
    code: string;
    title: string;
    subtitle?: string;
    icon?: IconDefinition;
    countryName?: string;
    subLocations?: T[];
    keywords?: string[];
    cityIataCode?: string;
}

export type ReserveInfo = {
    type: ReserveType;
    title: string;
    nameE?: string;
    icon: IconDefinition;
    link?: string;
};

export enum PaxType {
    Adult,
    Child,
    Infant,
    Seat,
    EmptySeat,
    Room,
}

export interface PaxTypeTitle {
    code: PaxType;
    title: string;
}

/**
 * Detailed information about passenger number of each type
 */
export interface PaxCount extends PaxTypeTitle {
    subtitle: string;
    count: number;
    countless?: boolean;
}

export type PaxCapacityInfo = {
    [key in PaxType]?: {
        count: number;
        min: number;
        max: number;
    };
};

export enum SearchMode {
    Domestic = 'domestic',
    Foreign = 'foreign',
}
